module.exports = __webpack_public_path__ + "img/Airbnb-Working-on-the-Move-Airplane-1.9bb248de.jpg";